module.exports = __webpack_public_path__ + "static/media/CSS2.a78b96c4.png";